export default __webpack_public_path__ + "static/Large_Crop_Plot-421393bf62ba847891b557c327cb908c.png";